/**
 * Checks is response error has 404 status
 */
export const getIsNotFound = (error) => {
  return error?.response?.status === 404;
};
